import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "../../src/js/api/queryClient";
import { HeroImageWidget } from "./components/hero-image/hero-image-widget";

function HeroImageRenderer() {
  const rootElement = document.getElementById(
    "my-profile__hero-image-widget"
  );
  if (!rootElement) return;

  createRoot(rootElement).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <HeroImageWidget
          heroUrl={rootElement.dataset.heroUrl}
        />
      </QueryClientProvider>
    </StrictMode>
  );
}

export const initHeroImage = () => {
  if (document.readyState !== "loading") {
    HeroImageRenderer();
  } else {
    document.addEventListener("DOMContentLoaded", HeroImageRenderer);
  }
};
